import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color } = theme.tokens;
  return {
    content: {
      margin: 0
    },
    downloadLinks: {
      margin: "16px 0 0",
      paddingTop: 16,
      boxShadow: `inset 0 1px 0 ${color.line}`,
      fontSize: theme.tokens.fontSize.ui,
      color: color.muted,
      "& a": { color: color.ink, fontWeight: 700 }
    }
  };
});

export default withCustomStyles;
